require('./EditFiscalDataForm.scss');

// @vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const classnames = require('classnames');
const PropTypes = require('prop-types');

// @commons
const { InputSafe } = require('commonsComponents/inputSafe');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')


// @components
const TaxAdditionalCountryForm = require('components/myProfile/taxAdditionalCountryList/taxAdditionalCountryForm');

// @constants
const { PREFIX_SPANISH_ISIN_CODE } = require('constants/index');
const { countryOptions } = require('constants/countries');
const PROVINCES = require('constants/provinces');
const PROVINCES_OPTIONS = Object.getOwnPropertyNames(PROVINCES).map(property => ({
    value: property,
    label: PROVINCES[property]
}));
const PROVINCES_OPTIONS_ORDERED = PROVINCES_OPTIONS.sort((a, b) => a.label.localeCompare(b.label));


class EditFiscalDataForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleDeleteCountry = this.handleDeleteCountry.bind(this);
        this.handleSaveCountry = this.handleSaveCountry.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.setEditingTaxAdditionalCountry = this.setEditingTaxAdditionalCountry.bind(this);
    }

    setEditingTaxAdditionalCountry(value, index) {
        const { setEditingTaxAdditionalCountry, actionChangeValue } = this.props;
        setEditingTaxAdditionalCountry && setEditingTaxAdditionalCountry(value, index);
        actionChangeValue && actionChangeValue({ taxAdditionalCountryIsEditing: value });
    }
    
    handleDeleteCountry(index) {
        const { deleteAdditionalCountries } = this.props;
        deleteAdditionalCountries && deleteAdditionalCountries(index);
    }
    
    handleInputChange(event) {
        const { actionChangeValue } = this.props;
        const { name } = event.target;
        let { value } = event.target;

        actionChangeValue && actionChangeValue({
            [name] : value, 
            [name+'Blur'] : false
        });
    }
    
    handleSaveCountry(index, data) {
        const { updateAdditionalCountries } = this.props;
        updateAdditionalCountries && updateAdditionalCountries(index, data);
    }
    
    handleSelectChange(event, name) {
        const { actionChangeValue } = this.props;
        const value = event.value || '';
        
        actionChangeValue && actionChangeValue({
            [name]: value,
            [name+'Blur'] : false
        });
    }

    buildTaxAdditionalError() {
        const { immProfileEditor } = this.props;
        const immStep = immProfileEditor.getIn(['steps', 0]);
        let formError;
        
        if (immProfileEditor.get('validateStepError')) {
            if (immStep.get('taxAdditionalCountryIsAdding') || immStep.get('listPaisesTributacionAdic').some((immCountry) => immCountry.get('isEditing'))) {
                const textEditingWarning = formatText('profile-profile_taxIsEditingWarning');
                formError = (
                    <div className="edit-form-step__error-wrapper">
                        <OKMessage
                            id="profile-editor-message-error"
                            type="warning"
                        >
                            {textEditingWarning}
                        </OKMessage>
                    </div>
                );
            }
        }

        return formError;
    }

    render() {
        const {setAddingTaxAdditionalCountry, onHandleNextDisableButton} = this.props;
        const birthCountry = formatText('profile-birthCountry');
        const birthLocality = formatText('profile-taxInformation_birthLocality');
        const birthLocationError = formatText('profile-incompleteBirthLocation');
        const birthProvince = formatText('profile-taxInformation_birthProvince');
        const dropdownError = formatText('profile-incompleteDropdown');
        const selectNotFound = formatText('profile-selectNotFound');
        const selectPlaceholder = formatText('profile-selectPlaceholder');
        const immStep = this.props.immProfileEditor.getIn(['steps', 0]);
        const immCountries = immStep.get('listPaisesTributacionAdic');
        const provinceClass = classnames('edit-form-step__input col-xs-4', { 'edit-form-step--hide': immStep.get('birthCountry').trim() !== PREFIX_SPANISH_ISIN_CODE });
        const birthCountryErrorState = immStep.get('birthCountryBlur') && immStep.get('birthCountry').trim() === '';
        const birthProvinceErrorState = immStep.get('birthProvinceBlur') && immStep.get('birthProvince').trim() === '';
        const birthSquareErrorState = immStep.get('birthSquareBlur') && immStep.get('birthSquare').trim() === '';
        const errorContent = this.buildTaxAdditionalError();
        const containerClass = contactCenterClassName('edit-fiscal-data-form__wrapper-tax-information');
        //GJ now is Palestina but only here we have a problem with this key, so we decided to remove it
        const countryOptionsFiltered = countryOptions().filter(country => country.value !== 'GJ');

        return (
            <div>
                <div className="row">
                    <div className="edit-form-step__input edit-form-step__input--margin-modifier col-xs-4">
                        <OKSelect
                            clearable={false}
                            label={birthCountry}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={selectNotFound}
                            onChange={(event) => this.handleSelectChange(event, 'birthCountry')}
                            options={countryOptionsFiltered}
                            placeholder={selectPlaceholder}
                            value={immStep.get('birthCountry')}
                            errorState={birthCountryErrorState}
                            errorMessage={dropdownError}
                        />
                    </div>
                    <div className={provinceClass}>
                        <OKSelect
                            clearable={false}
                            label={birthProvince}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={selectNotFound}
                            onChange={(event) => this.handleSelectChange(event, 'birthProvince')}
                            options={PROVINCES_OPTIONS_ORDERED}
                            placeholder={selectPlaceholder}
                            value={immStep.get('birthProvince')}
                            errorState={birthProvinceErrorState}
                            errorMessage={dropdownError}
                        />
                    </div>
                    <div className="edit-form-step__input col-xs-4">
                        <InputSafe
                            label={birthLocality}
                            name="birthSquare"
                            onChange={this.handleInputChange}
                            type="text"
                            value={immStep.get('birthSquare')}
                            errorState={birthSquareErrorState}
                            errorMessage={birthLocationError}
                        />
                    </div>
                </div>
                
                <div className={containerClass}>
                    <OKInformativeList columns={1} title="profile-taxInformation_CountriesAdditionalTributationTitle">
                        {errorContent}
                        <TaxAdditionalCountryForm
                            onHandleNextDisableButton={onHandleNextDisableButton}
                            immCountries={immCountries}
                            onDeleteCountry={this.handleDeleteCountry}
                            onSaveCountry={this.handleSaveCountry}
                            setAddingTaxAdditionalCountry={setAddingTaxAdditionalCountry}
                            setEditingTaxAdditionalCountry={this.setEditingTaxAdditionalCountry}
                        />
                    </OKInformativeList>
                </div>

            </div>
        );
    }
}

EditFiscalDataForm.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    deleteAdditionalCountries: PropTypes.func.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    updateAdditionalCountries: PropTypes.func.isRequired,
    setAddingTaxAdditionalCountry: PropTypes.func.isRequired,
    setEditingTaxAdditionalCountry: PropTypes.func.isRequired,
    onHandleNextDisableButton: PropTypes.func
}

module.exports = EditFiscalDataForm;